module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"PageTermsList":{"breadcrumbs":{"index":"Výkladový slovník"},"heading":{"main":"Výkladový slovník"},"seo":{"description":"Výrazy, které neznáte obsahuje náš výkladový slovník","keywords":"Slovník, výkladový slovník, {website}","title":"Výkladový slovník"}}}}')
  delete Component.options._Ctor
}
